import create from "zustand";
import React, {useState} from "react";
import "./Terminal.css"
import {DirectoryStore} from "./Directory/Directory";

enum TerminalLineType {
    COMMAND,
    OUTPUT,
}

interface TerminalLineProps {
    type: TerminalLineType;
    color?: string;
    username?: string;
    directory?: string;
    lines: string[];
}

interface HistoryStoreState {
    history: TerminalLineProps[];
    addLine: (line: TerminalLineProps) => void;
    resetHistory: () => void;
}

interface TerminalState extends HistoryStoreState {
    user: string;
    setUser: (user: string) => void;
    processing: boolean
    setProcessing: (processing: boolean) => void;
    processCommand: (command: string) => void;
}


export const useTerminalStore = create<TerminalState>((set) => ({
    processing: false,
    setProcessing: (processing: boolean) => set(() => {
        return {processing: processing}
    }),
    user: "k4",
    setUser: (user: string) => set(() => {
        return {user: user}
    }),
    processCommand: (command: string) => {
        set(() => {
            return {processing: true}
        })
        setTimeout(() => {
            set(() => {
                return {processing: false}
            })
        }, 1000)
    },
    history: [],
    addLine: (line: TerminalLineProps) => set((state) => {
            return {history: [...state.history, line]};
        }
    ),
    resetHistory: () => set(() => {
            return {history: []};
        }
    ),
}))


export const TerminalLine = (props: TerminalLineProps) => {
    let lines = [];
    for (let line of props.lines) {
        lines.push(<p className={'terminal-p'}>{line}</p>);
    }
    return (
        <div className={"terminal-line"}>
            {props.type === TerminalLineType.COMMAND &&
                <>
                    <p className={'terminal-p'} style={{color: props.color}}>{props.username}:</p>
                    <p className={'terminal-p'}>{props.directory}</p>
                    <p className={'terminal-p'}>$&nbsp;</p>
                </>
            }
            {lines}
        </div>
    )
};

export default function Terminal() {
    const [currentLine, setCurrentLine] = useState<string>("sd");
    DirectoryStore(state => state.getActiveDirectory);
    const history = useTerminalStore(state => state.history);
    const addLine = useTerminalStore(state => state.addLine);
    useTerminalStore(state => state.resetHistory);
    const processing = useTerminalStore(state => state.processing);
    useTerminalStore(state => state.setProcessing);
    const user = useTerminalStore(state => state.user);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        console.log(event)
        const key = event.key;
        if (key.length === 1 && key.match(/[a-zA-Z0-9- ]/)) { // if key in [a-z, A-Z, 0-9, -_, space]
            setCurrentLine(currentLine + key);
            //    enter key
        } else if (key === "Enter") {
            setCurrentLine("");
            addLine({
                type: TerminalLineType.COMMAND,
                username: "k4",
                directory: "/home/k4",
                lines: [currentLine]
            });
            // backspace
        } else if (key === "Backspace") {
            setCurrentLine(currentLine.substring(0, currentLine.length - 1));
        } else {
            console.log('Not Supported key: ' + key);
        }
    }

    return (
        <div className={"full-screen terminal"} tabIndex={-1} onKeyDown={handleKeyDown}>
            {history.map((line, index) => <TerminalLine key={index} {...line}/>)}
            {!processing &&
                <TerminalLine type={TerminalLineType.COMMAND} lines={[currentLine]} directory={''}
                              username={user}/>}
        </div>
    )
}
